module.exports['Visa'] = {
  icon: require('./Visa.svg'),
  color: '#3957A7',
};
module.exports['Mastercard'] = {
  icon: require('./Mastercard.svg'),
  color: '#13457C',
};

module.exports['MasterCard'] = {
  icon: require('./Mastercard.svg'),
  color: '#13457C',
};

module.exports['Diners Club'] = {
  icon: require('./Diners Club.svg'),
  color: '#084D95',
};
module.exports['JCB'] = {
  icon: require('./JCB.svg'),
  color: '#0C489C',
};
module.exports['Maestro'] = {
  icon: require('./Maestro.svg'),
  color: '#13457C',
};
module.exports['American Express'] = {
  icon: require('./American Express.svg'),
  color: '#0078A9',
};
module.exports['Discover'] = {
  icon: require('./Discover.svg'),
  color: '#F58220',
};

module.exports['bank'] = {
  icon: require('./bank.svg'),
  color: '#66b2aa',
};
